export default __webpack_public_path__ + "static/media/Mask Group 20.b6e54d52.png";